module.exports = __webpack_public_path__ + "img/26-wagoneer.4e9726f8.jpg";